import { Form, FormGroup, FormFeedback, Alert, Spinner } from "reactstrap";
import { AuthButton, AuthContainer, AuthInput } from "./style";
import Link from "../common/Link";
import { setAuthenticatedUser, fetchOtp, loginOtp } from "./service";
import React, { useState, useContext, useEffect } from "react";
import { CoreContainer } from "../common/style";
import { isMobile } from "react-device-detect";
import OtpVerification from "./OtpVerification";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context";

function LoginWithOtp({ user }) {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpVerification, setShowOtpVerification] = useState(false);
  const navigate = useNavigate();
  const { setOrganizationData } = useContext(AppContext);

  const enableLogin = mobileNumber.length === 10 && /^\d+$/.test(mobileNumber);

  useEffect(() => {
    if (showOtpVerification) {
      setError(null);
    }
  }, [showOtpVerification]);

  function triggerGetOtp() {
    setIsLoading(true);
    setError(null);
    fetchOtp({ mobileNumber, from: "login" })
      .then(() => {
        setShowOtpVerification(true);
      })
      .catch(({ error }) => {
        setError(error);
      })
      .finally(() => setIsLoading(false));
  }

  function doLogin(fullOtp) {
    setIsLoading(true);
    setError(null);

    loginOtp({ mobileNumber, otp: fullOtp })
      .then(({ token, user, plan_features }) => {
        setAuthenticatedUser({ token, user });
        setOrganizationData(plan_features);
        navigate("/projects", {
          state: { setIdentity: true },
        });
      })
      .catch(({ error }) => {
        setError(error);
      })
      .finally(() => setIsLoading(false));
  }

  return showOtpVerification ? (
    <OtpVerification
      mobileNumber={mobileNumber}
      setShowOtpVerification={setShowOtpVerification}
      onSuccess={doLogin}
      error={error}
      setError={setError}
      isLoading={isLoading}
      triggerGetOtp={triggerGetOtp}
    />
  ) : (
    <CoreContainer height={isMobile ? "unset" : null}>
      <AuthContainer className="px-4 px-sm-5 pt-4 pb-2 rounded-3">
        <h4 className="text-center mt-2"> LOGIN </h4>
        <Form>
          <FormGroup>
            <AuthInput
              invalid={
                mobileNumber.length > 0 &&
                (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber))
              }
              type="text"
              value={mobileNumber}
              placeholder="Mobile Number"
              onChange={(ev) => setMobileNumber(ev.target.value)}
            />
            <FormFeedback>
              Please enter a valid 10 digit Mobile number.
            </FormFeedback>
          </FormGroup>
          {error && <Alert color="danger">{error} &nbsp;</Alert>}
          <div className="d-grid gap-2 mt-4 mb-3 pt-3">
            <AuthButton
              onClick={triggerGetOtp}
              disabled={!enableLogin || isLoading}
              color="primary"
            >
              {isLoading ? (
                <>
                  <Spinner size="sm">Loading...</Spinner> &nbsp;
                  <span>Loading...</span>
                </>
              ) : (
                "Send WhatsApp OTP"
              )}
            </AuthButton>
          </div>
          {/* FIXME: Temporarily disabled until AWS SMS quota is granted*/}
          {!user && (
            <p className="text-center">
              <Link
                to="/login"
                children="Login with Password"
                fontWeight="700"
                color="black"
              />
            </p>
          )}

          {!user && (
            <p className="text-center">
              Don't have an account? &nbsp;
              <Link
                to="/register"
                children="Register Here"
                fontWeight="700"
                color="black"
              />
            </p>
          )}
        </Form>
      </AuthContainer>
    </CoreContainer>
  );
}

export default LoginWithOtp;
